// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.products-page__crumb {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: #64748b;
}

.products-page__crumb-current {
  color: #0f172a;
  font-weight: 600;
}

.products-page .cidx-toolbar__filters .cidx-search {
  max-width: 420px;
}

.products-page__filters {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.products-page__filters .cidx-select {
  min-width: 168px;
}

.prod-name {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  max-width: 100%;
}

.prod-name__dot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  flex-shrink: 0;
}

.prod-name__dot.is-in {
  background: #10b981;
}

.prod-name__dot.is-out {
  background: #ef4444;
}

.prod-qty {
  font-size: 13px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.prod-qty.is-in {
  color: #059669;
}

.prod-qty.is-out {
  color: #ef4444;
}

.prod-qty__unit {
  margin-inline-start: 4px;
  font-weight: 600;
}

.prod-category {
  color: #334155;
  font-size: 13px;
}

.products-page .cidx-mono.is-id {
  color: #64748b;
  font-weight: 500;
}

.products-page .cidx-row-link.is-plain {
  height: auto;
  padding: 0;
  border: 0;
  background: transparent;
  box-shadow: none;
  color: #64748b;
  font-weight: 600;
}

.products-page .cidx-row-link.is-plain:hover {
  background: transparent;
  color: #0284c7;
}
`, "",{"version":3,"sources":["webpack://./src/pages/inventory/Products/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB","sourcesContent":[".products-page__crumb {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  font-size: 13px;\n  font-weight: 500;\n  color: #64748b;\n}\n\n.products-page__crumb-current {\n  color: #0f172a;\n  font-weight: 600;\n}\n\n.products-page .cidx-toolbar__filters .cidx-search {\n  max-width: 420px;\n}\n\n.products-page__filters {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.products-page__filters .cidx-select {\n  min-width: 168px;\n}\n\n.prod-name {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.prod-name__dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 9999px;\n  flex-shrink: 0;\n}\n\n.prod-name__dot.is-in {\n  background: #10b981;\n}\n\n.prod-name__dot.is-out {\n  background: #ef4444;\n}\n\n.prod-qty {\n  font-size: 13px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.prod-qty.is-in {\n  color: #059669;\n}\n\n.prod-qty.is-out {\n  color: #ef4444;\n}\n\n.prod-qty__unit {\n  margin-inline-start: 4px;\n  font-weight: 600;\n}\n\n.prod-category {\n  color: #334155;\n  font-size: 13px;\n}\n\n.products-page .cidx-mono.is-id {\n  color: #64748b;\n  font-weight: 500;\n}\n\n.products-page .cidx-row-link.is-plain {\n  height: auto;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  box-shadow: none;\n  color: #64748b;\n  font-weight: 600;\n}\n\n.products-page .cidx-row-link.is-plain:hover {\n  background: transparent;\n  color: #0284c7;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
